import { defineAsyncComponent, ref } from 'vue'
import { computedAsync } from '@vueuse/core'
import DefaultLayout from '@/composables/useLayouts/layouts/DefaultLayout.vue'
import BlankLayout from '@/composables/useLayouts/layouts/BlankLayout.vue'
import { ELayout } from '@/composables/useLayouts/types'

const currentLayout = ref<ELayout>(ELayout.BLANK)

const options = Object.entries(ELayout)
    .map(([title, value]) => ({ title, value }));


const layout = computedAsync(
    async () => {
        /*
        https://vueuse.org/core/computedAsync/
        Dependencies that are accessed asynchronously will not trigger re-evaluation of the async computed value.
        */
        const temp = currentLayout.value
        return defineAsyncComponent({
            loader: () =>
                import(`./layouts/${currentLayout.value}Layout.vue`),
            //A component to use while the async component is loading
            loadingComponent: BlankLayout,
            // Delay before showing the loading component. Default: 200ms.
            delay: 200,

            // A component to use if the load fails
            errorComponent: BlankLayout,
            // The error component will be displayed if a timeout is
            // provided and exceeded. Default: Infinity.
            timeout: 3000,
        })
    },
    BlankLayout, // initial state
)


export const useLayout = () => {

    const switchLayout = (v:ELayout) => currentLayout.value = v


    return { layout, switchLayout, currentLayout, options }
}